// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.full-action-modal-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 99999;
}
.full-action-modal-wrapper.if-modal-slide {
  border-radius: 4px;
  background: var(--sdk-global-white-bg);
  box-shadow: 0px 0px 82px 0px rgba(0, 0, 0, 0.24);
  top: 40px;
  left: 20px;
  width: calc(100% - 445px);
  height: calc(100% - 80px);
  -webkit-animation-name: slideInRight;
  animation-name: slideInRight;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}
.full-action-modal-wrapper.if-modal-slide .modal_backdrop {
  display: none;
}
.full-action-modal-wrapper.if-modal-slide .modal-dialog-action {
  width: 100%;
  height: 100%;
  display: block;
}
.full-action-modal-wrapper.if-modal-slide .modal-dialog-action .modal-content-action {
  animation: none;
  height: 100%;
  max-height: 100%;
}
.full-action-modal-wrapper .modal_backdrop {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  position: absolute;
  z-index: -1;
}
.full-action-modal-wrapper .modal-dialog-action {
  width: 600px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}
.full-action-modal-wrapper .modal-dialog-action .modal-content-action {
  border-radius: 4px;
  background: var(--sdk-global-white-bg);
  width: 100%;
  max-height: 80%;
  display: flex;
  flex-direction: column;
  -webkit-animation-name: zoomIn;
  animation-name: zoomIn;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}
.full-action-modal-wrapper .modal-dialog-action .modal-content-action .modal_header {
  display: flex;
  align-items: center;
  padding: 16px;
  flex-shrink: 0;
}
.full-action-modal-wrapper .modal-dialog-action .modal-content-action .modal_header h1 {
  width: 100%;
  color: var(--sdk-gloabl-text-color);
  font-size: 14px;
  font-weight: 700;
  line-height: normal;
}
.full-action-modal-wrapper .modal-dialog-action .modal-content-action .modal_header .close_modal {
  width: 16px;
  height: 16px;
  border: 0;
  padding: 0;
  background: transparent;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--sdk-gloabl-text-color);
}
.full-action-modal-wrapper .modal-dialog-action .modal-content-action .modal_body_actions {
  flex: 1 1 auto;
  overflow: auto;
}`, "",{"version":3,"sources":["webpack://./src/templatemanager/base/actionsModal/actionsModal.scss"],"names":[],"mappings":"AAEA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AADJ;AAEI;EACI,kBAAA;EACA,sCAAA;EACA,gDAAA;EACA,SAAA;EACA,UAAA;EACA,yBAAA;EACA,yBAAA;EACA,oCAAA;EACA,4BAAA;EACA,8BAAA;EACA,sBAAA;EACA,iCAAA;EACA,yBAAA;AAAR;AACQ;EACI,aAAA;AACZ;AACQ;EACI,WAAA;EACA,YAAA;EACA,cAAA;AACZ;AAAY;EACI,eAAA;EACA,YAAA;EACA,gBAAA;AAEhB;AAEI;EACI,WAAA;EACA,YAAA;EACA,8BAAA;EACA,kBAAA;EACA,WAAA;AAAR;AAEI;EACI,YAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AAAR;AACQ;EACI,kBAAA;EACA,sCAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,sBAAA;EACA,8BAAA;EACA,sBAAA;EACA,iCAAA;EACA,yBAAA;AACZ;AAAY;EACI,aAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;AAEhB;AADgB;EACI,WAAA;EACA,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAGpB;AADgB;EACI,WAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,uBAAA;EACA,eAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mCAAA;AAGpB;AAAY;EACI,cAAA;EACA,cAAA;AAEhB","sourcesContent":["\n\n.full-action-modal-wrapper{\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 99999;\n    &.if-modal-slide{\n        border-radius: 4px;\n        background: var(--sdk-global-white-bg);\n        box-shadow: 0px 0px 82px 0px rgba(0, 0, 0, 0.24);\n        top: 40px;\n        left: 20px;\n        width: calc(100% - 445px);\n        height: calc(100% - 80px);\n        -webkit-animation-name: slideInRight;\n        animation-name: slideInRight;\n        -webkit-animation-duration: 1s;\n        animation-duration: 1s;\n        -webkit-animation-fill-mode: both;\n        animation-fill-mode: both;\n        .modal_backdrop{\n            display: none;\n        }\n        .modal-dialog-action{\n            width: 100%;\n            height: 100%;\n            display: block;\n            .modal-content-action{\n                animation: none;\n                height: 100%;\n                max-height: 100%;\n            }\n        }\n    }\n    .modal_backdrop{\n        width: 100%;\n        height: 100%;\n        background: rgba(0, 0, 0, 0.60);\n        position: absolute;\n        z-index: -1;\n    }\n    .modal-dialog-action{\n        width: 600px;\n        height: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        margin: 0 auto;\n        .modal-content-action{\n            border-radius: 4px;\n            background: var(--sdk-global-white-bg);\n            width: 100%;\n            max-height: 80%;\n            display: flex;\n            flex-direction: column;\n            -webkit-animation-name: zoomIn;\n            animation-name: zoomIn;\n            -webkit-animation-duration: 1s;\n            animation-duration: 1s;\n            -webkit-animation-fill-mode: both;\n            animation-fill-mode: both;\n            .modal_header{\n                display: flex;\n                align-items: center;\n                padding: 16px;\n                flex-shrink: 0;\n                h1{\n                    width: 100%;\n                    color: var(--sdk-gloabl-text-color);\n                    font-size: 14px;\n                    font-weight: 700;\n                    line-height: normal;\n                }\n                .close_modal{\n                    width: 16px;\n                    height: 16px;\n                    border: 0;\n                    padding: 0;\n                    background: transparent;\n                    font-size: 16px;\n                    cursor: pointer;\n                    display: flex;\n                    align-items: center;\n                    justify-content: center;\n                    color: var(--sdk-gloabl-text-color);\n                }\n            }\n            .modal_body_actions{\n                flex: 1 1 auto;\n                overflow: auto;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
